import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getIsLoggedIn } from '@selectors/auth';
import useTestAccess from '../Details/Description/Actions/useSkuAccessForTest';

const useHideTestCTA = ({ quizUID, isSpecial, isCbt, isSubscribedUser }) => {
  const isLoggedIn = useSelectorWithShallowEqual(getIsLoggedIn);

  const { isTestAccessPresent, refetchUam, isUamValidating } = useTestAccess(
    quizUID,
    'Quiz:Join',
    'Quiz',
    isCbt ? false : isSubscribedUser,
    isSpecial
  );

  const hideTestCTA = isCbt
    ? !isSpecial && !isTestAccessPresent
    : !isSpecial && !isSubscribedUser && !isTestAccessPresent;

  return { hideTestCTA, isTestAccessPresent, refetchUam, isUamValidating };
};

export default useHideTestCTA;
